export const translate = (str, translator) => {
  if (!str) return;
  const regExp = /\w+\.\w+/;
  const mt = str.match(regExp);
  if (mt) {
    return str.replace(regExp, translator(mt[0]));
  }
  return str;
};
export const currencyFormatter = function () {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  let localeOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    style: 'currency',
    currency: 'USD'
  };
  return value.toLocaleString(locale, localeOptions);
};